module.exports = __webpack_public_path__ + "static/media/FileText.46adbee2.svg";